module.exports = __webpack_public_path__ + "static/media/BAT-BAKE.db4845d8.svg";